import RepositoryFactory from "../../marcom/Apicall/RepositoryFactory";
// import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  add({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await RepositoryFactory.segment.add(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  addMembers({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await RepositoryFactory.segment.addMembersInSegment(
          payload
        );

        // commit("ADD_MEMBERS_IN_SEGMENT", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  removeMember({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("api called");
        const { data } = await RepositoryFactory.segment.removeMember(payload);

        // commit("ADD_MEMBERS_IN_SEGMENT", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllSegment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.segment.getAllSegment(payload);

        // commit("ADD_MEMBERS_IN_SEGMENT", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  SegmentDelete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.segment.deleteSegment(payload);

        // commit("ADD_MEMBERS_IN_SEGMENT", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllSegmentUser({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.segment.getAllSegmentUser(
          payload
        );

        // commit("ADD_MEMBERS_IN_SEGMENT", { key: "members", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
